// extracted by mini-css-extract-plugin
export default {"background-section":"Head_background-section__TYVUr","main":"Head_main__PZO9p","div":"Head_div__owh8W","scroll-up":"Head_scroll-up__93zrd"};